import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { lastValueFrom, Observable, Subject } from 'rxjs';
import { IdentityUserAccount, IUserInfo, User } from 'src/app/models';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class UserService {
  private IDENTITY_SERVICE_URL = environment.identityService.url + environment.identityService.apiVersion;

  private lookups = new Map<string, any>();
  private usersLookupKey: string;

  constructor(private http: HttpClient) {
    this.usersLookupKey = "users";
  }

  AuthenticateSigningUser(userAuth: any): Promise<IdentityUserAccount> {
    return new Promise<IdentityUserAccount>((resolve, reject) => {
      this.http
        .post<IdentityUserAccount>(this.IDENTITY_SERVICE_URL + "Account/AuthenticateSigningUser", userAuth)
        .toPromise()
        .then(
          (users?: IdentityUserAccount) => {
            resolve(users!);
          },
          (err) => {
            reject(err);
          });
    });
  }

  GetUserInfo(userId: number): Promise<IUserInfo> {
    return new Promise<IUserInfo>((resolve, reject) => {
      lastValueFrom(this.http.post<IUserInfo>(this.IDENTITY_SERVICE_URL + "Users/GetUserDetails", userId))
        .then(
          (user?: IUserInfo) => {
            resolve(user!);
          },
          (err) => {
            reject(err);
          });
    });
  }

  getUsers(): Promise<User[]> {
    return new Promise<User[]>((resolve, reject) => {
      if (this.lookups.has(this.usersLookupKey)) {
        resolve(this.lookups.get(this.usersLookupKey));
      } else {
        this.http
          .get<User[]>(this.IDENTITY_SERVICE_URL + "Users/Medpt")
          .toPromise()
          .then(
            (users) => {
              this.lookups.set(this.usersLookupKey, users);
              if (users != null)
                resolve(users);
            },
            (err) => {
              reject(err);
            }
          );
      }
    });
  }
}
